import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { Stack, Typography } from "@mui/material";
import maintenanceLogo from "../../../assets/Card/maintenanceLogo.png";
import urgentLogo from "../../../assets/Card/urgentLogo.png";
import { useGetMaintainanceDashboardQuery } from "../../../Api/apiSlice";
export default function DashboardMaintenanceCard({}) {
  const { data, error, isLoading } = useGetMaintainanceDashboardQuery();
  console.log("Card Data", data?.upcomingMaintenance);

  return (
    <Box sx={{ height: "auto" }}>
      <Card
        variant="outlined"
        sx={{
          border: "1px ",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.6)",
          height: "100%",
          // minHeight: "180px",
        }}
      >
        <React.Fragment>
          <Stack direction={"column"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              p={2}
            >
              <Box
                sx={{
                  width: { md: "44px" },
                  // height: { md: "44px" },
                  backgroundColor: "#FFF4F2",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "2px",
                }}
              >
                <img src={maintenanceLogo} height={"18px"} width={"18px"} />
              </Box>
              <Typography
                sx={{
                  fontSize: {
                    xs: "10px", // Extra small screens
                    md: "10  px", // Medium screens
                    lg: "12px", // Large screens
                    xl: "14px",
                  },
                  color: "#5A607F",
                  fontWeight: 400,
                  fontFamily: "Inter, sans-serif",
                }}
                noWrap
              >
                Upcoming Maintenance
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "18px", // Extra small screens

                    md: "20px", // Medium screens
                    lg: "22px", // Large screens
                    xl: "24px",
                  },
                  color: "#2A3547",
                  fontWeight: 600,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {data?.upcomingMaintenance ? data?.upcomingMaintenance : 0}
              </Typography>
            </Stack>
            <Stack p={1} direction={"row"}>
              
            </Stack>
          </Stack>
        </React.Fragment>
      </Card>
    </Box>
  );
}
